const formatUserInfo = (user: any) => {
  return user
    ? {
        ...user,
        name: user.name || user.wechatName || user.wechat_name || "",
        // React DevTools error log use null rather than ""
        avatar: user.avatarUrl || user.avatar_url || null,
        admin: user.admin,
        manager: user.manager,
        invited: user.invited,
        isShowedModifyName: !user.name,
      }
    : {
        id: null,
        avatar: null,
      };
};

export { formatUserInfo };
